import { formatPrice } from '@olo-web/domain/orders/functions/formatPrice';

export const formatModifierOptionLabel = (option) => {
  let text = option?.name;
  if (Number(option.price) > 0) {
    text += ` (+ ${formatPrice(option.price)})`;
  }
  return text;
};
